<div class="uk-card-default rapport-content">
  <h4 class="ml">Évaluez la session et ajoutez vos commentaires pour chacun des thèmes ci-dessous :</h4>
  <form>
    <table class="uk-table uk-table-small uk-table-divider">
      <tr>
        <th></th>
        <th>1</th>
        <th>2</th>
        <th>3</th>
        <th>4</th>
        <th>5</th>
      </tr>
      <tr *ngFor="let rapport of rapportIntervevant">
        <td class="uk-width-1-6">
          {{ rapport.titre }}<br />
          <div class="mt mb"><i class="small material-icons ">info_outline</i>{{ rapport.info_outline }}<br /></div>
          <textarea
            #{{rapport.code}}
            name="{{ rapport.code }}"
            [(ngModel)]="rapport.commentaire"
            id="{{ rapport.code }}"
            cols="100"
            rows="5"
          ></textarea>
        </td>

        <td>
          <label>
            <input
              type="checkbox"
              class="checkbox"
              value="1"
              name="1"
              [checked]="rapport.note === 1"
              (change)="toggleRapport(1, rapport)"
            />
            <span></span>
          </label>
        </td>
        <td>
          <label>
            <input
              type="checkbox"
              class="checkbox"
              value="2"
              name="2"
              [checked]="rapport.note === 2"
              (change)="toggleRapport(2, rapport)"
            />
            <span></span>
          </label>
        </td>
        <td>
          <label>
            <input
              type="checkbox"
              class="checkbox"
              value="3"
              name="3"
              [checked]="rapport.note === 3"
              (change)="toggleRapport(3, rapport)"
            />
            <span></span>
          </label>
        </td>
        <td>
          <label>
            <input
              type="checkbox"
              class="checkbox"
              value="4"
              name="4"
              [checked]="rapport.note === 4"
              (change)="toggleRapport(4, rapport)"
            />
            <span></span>
          </label>
        </td>
        <td>
          <label>
            <input
              type="checkbox"
              class="checkbox"
              value="5"
              name="5"
              [checked]="rapport.note === 5"
              (change)="toggleRapport(5, rapport)"
            />
            <span></span>
          </label>
        </td>
      </tr>
    </table>

    <button
      kendoButton
      class="k-button k-primary colored-text mr mb primary-background"
      style="float: right;"
      onclick="UIkit.notification({message: 'Rapport validé ', pos: 'top-right'})"
      (click)="valider()"
      >Valider</button
    >
  </form>
</div>
